export const environment = {
    production: true,
    // API_ENDPOINT: 'http://server.iaeste.sk:8180/aosdb/api',
    API_ENDPOINT: 'https://api.aosdb.zitrochu.sk/aosdb/api',
};
